<template>
    <div class="lgs-status lm-border bg-white">
        <div class="lgs-status-button">
            <c-toolbar-button
                icon    = "mdi-router-wireless"
                size    = "20"
                color   = "primary"
                :tooltip = "$t('lgsmart.refresh')"
               @click   = "load"
            />
        </div>

        <div v-if="!liftBox" class="label">
            {{ $t('lgsmart.noData') }}
        </div>

        <div v-for="(device, index) in devices" :key="device.key" :class="{'mt-4': index > 0}">
            <v-row no-gutters>
                <v-col class="v-col-6 bold">
                    {{ $t('lgsmart.sensor.' + device.key + '.name') }}
                </v-col>
                <v-col class="v-col-6 eid">
                    {{ device.eid ? device.eid : '---' }}
                </v-col>
            </v-row>

            <template v-if="device.eid">
                <v-row no-gutters v-if="device.firmware">
                    <v-col class="v-col-6 label">
                        {{ $t('lgsmart.firmware') }}
                    </v-col>
                    <v-col class="value">
                        {{ device.firmware }}
                    </v-col>
                </v-row>

                <v-row no-gutters v-if="device.pairTime">
                    <v-col class="v-col-6 label">
                        {{ $t('lgsmart.pairTime') }}
                    </v-col>
                    <v-col class="value">
                        {{ toDateString (device.pairTime) }}
                    </v-col>
                </v-row>

                <v-row no-gutters v-if="liftboxState">
                    <v-col class="v-col-6 label">
                        Status
                    </v-col>
                    <v-col class="value">
                        <div v-if="device.states.length === 0" class="success--text">
                            {{ $t('lgsmart.state.ok') }}
                        </div>
                        <div v-for="item in device.states" :key="item.state" class="error--text">
                            {{ $t('lgsmart.state.' + item.state) }}
                            <span v-if="item.since">{{ $t('lgsmart.since') }} {{ toDateString (item.since) }}</span>
                        </div>
                    </v-col>
                </v-row>
            </template>
        </div>
    </div>
</template>

<script>
import Core from "@/modules/core/service/Core";
import Lgs from "@/modules/lgs/events/service/Lgs";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

// Panel key -> iot-api-svc SensorType
const SENSORS = [
    { key: "DOOR_1",    type: "DOOR" },
    { key: "DOOR_2",    type: "DOOR_2" },
    { key: "REFERENCE", type: "REFERENCE" },
];

export default {
    name: "CUnitLgSmart",
    components: {CToolbarButton},

    props: {
        siteId: {

        },
        // Only sites with an LG Smart device are known to iot-api-svc; without one we don't ask.
        hasDevice: {
            type   : Boolean,
            default: false
        },
    },

    data: () => ({
        liftBox     : null,
        liftboxState: null,
    }),

    computed: {
        devices () {
            if (!this.liftBox) {
                return [];
            }

            const gateway = this.liftBox.gateway;
            const sensors = this.liftBox.sensors || {};
            const sensorStates = this.liftboxState ? this.liftboxState.sensorStates || {} : {};

            return [
                {
                    key     : "GATEWAY",
                    eid     : gateway ? gateway.eid : null,
                    firmware: gateway ? gateway.firmware : null,
                    pairTime: null,
                    states  : this.liftboxState ? this.liftboxState.gatewayStates || [] : [],
                },
                ...SENSORS.map(sensor => {
                    const data = sensors[sensor.type];
                    return {
                        key     : sensor.key,
                        eid     : data ? data.eid : null,
                        firmware: data ? data.firmware : null,
                        pairTime: data ? data.pairTime : null,
                        states  : sensorStates[sensor.type] || [],
                    };
                })
            ];
        }
    },

    mounted() {
        this.load();
    },

    watch: {
        siteId () {
            this.load();
        },
        hasDevice () {
            this.load();
        }
    },

    methods: {
        load () {
            this.liftBox      = null;
            this.liftboxState = null;
            if (!this.siteId || !this.hasDevice) {
                return;
            }

            const siteId = this.siteId;
            Lgs.site(siteId).then(site => {
                if (siteId !== this.siteId) {
                    return;
                }

                this.liftBox      = site.liftBox;
                this.liftboxState = site.state ? site.state.liftboxState : null;
            }).catch(() => {
                // Site unknown to iot-api-svc (no LiftGuardian) or caller not allowed: panel shows "no data".
            });
        },

        toDateString (value) {
            if (!value) {
                return "..."
            }

            return Core.format.datetime.display(value)
        }
    }
}
</script>

<style scoped>

.lgs-status {
    font-size: 16px;
    padding: 12px;
    position: relative;
}

.lgs-status-button {
    position: absolute;
    right:8px;
    top: 8px;
}

.eid {
    color: gray;
    font-size: 13px;
    padding-top: 2px!important;
}

.bold {
    font-weight: 500;
}

.label {
    font-size: 13px;
    padding-top: 2px;
    padding-bottom: 2px;
}

.value {
    font-size: 13px;
    padding-top: 2px;
    padding-bottom: 2px;
}

</style>
